import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

// Gates /employees/* to signed-in @qualitypower.co.in accounts. The backend
// enforces this for real on every request; this is just the UI-side redirect
// so non-employees don't see a blank/broken page.
const EmployeeRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  const stateUser = location.state?.user;
  const effectiveUser = stateUser || user;

  if (loading && !stateUser) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-10 h-10 rounded-full border-2 border-qcyan/30 border-t-qcyan animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated && !stateUser) {
    return <Navigate to="/" replace state={{ requireLogin: true }} />;
  }

  if (effectiveUser && !effectiveUser.is_employee) {
    return <Navigate to="/portal" replace />;
  }

  return children;
};

export default EmployeeRoute;
